import { debugLog } from "../../../utils/debug";
import decodeHtml from '../../../Uitiles/decodeHtml';
import ImageShow from '../../../Uitiles/ImageShow';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FileDownload from '../../Doctor/Components/ProfileSettings/FileDownload';
import './DoctorGalleryPopup.css';
import './DoctorDetails.css';
import FeedbackPopup from './FeedbackPopup';

const SOCIAL_ICONS = {
    facebook: { icon: "fab fa-facebook-f", label: "Facebook" },
    twitter: { icon: "fab fa-twitter", label: "Twitter" },
    linkedin: { icon: "fab fa-linkedin-in", label: "LinkedIn" },
    instagram: { icon: "fab fa-instagram", label: "Instagram" },
    youtube: { icon: "fab fa-youtube", label: "YouTube" },
    pinterest: { icon: "fab fa-pinterest-p", label: "Pinterest" },
    skype: { icon: "fab fa-skype", label: "Skype" },
    tumblr: { icon: "fab fa-tumblr", label: "Tumblr" },
    flickr: { icon: "fab fa-flickr", label: "Flickr" },
    medium: { icon: "fab fa-medium-m", label: "Medium" },
    tripadvisor: { icon: "fab fa-tripadvisor", label: "TripAdvisor" },
    wikipedia: { icon: "fab fa-wikipedia-w", label: "Wikipedia" },
    vimeo: { icon: "fab fa-vimeo-v", label: "Vimeo" },
    whatsapp: { icon: "fab fa-whatsapp", label: "WhatsApp" },
    vkontakte: { icon: "fab fa-vk", label: "VK" },
    odnoklassniki: { icon: "fab fa-odnoklassniki", label: "Odnoklassniki" },
    googleplus: { icon: "fab fa-google-plus-g", label: "Google Plus" },
    telegram: { icon: "fab fa-telegram-plane", label: "Telegram" },
    twitch: { icon: "fab fa-twitch", label: "Twitch" },
    discord: { icon: "fab fa-discord", label: "Discord" },
    github: { icon: "fab fa-github", label: "Github" },
    reddit: { icon: "fab fa-reddit-alien", label: "Reddit" },
    stackoverflow: { icon: "fab fa-stack-overflow", label: "Stack Overflow" },
};

const DoctorDetails = ({ data = {}, doctorDetails = {}, loadtype = 'doctors' }) => {
    debugLog('doctor details data and doctorDetails:', doctorDetails);
    console.log('doctor details data and doctorDetails loadtype:', loadtype);

    const [openService, setOpenService] = useState(null);
    const [galleryTab, setGalleryTab] = useState('images');
    const [popupIndex, setPopupIndex] = useState(null);
    const [popupType, setPopupType] = useState('images');
    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
    const [openExperience, setOpenExperience] = useState(false);
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

    // Safe JSON parsing with error handling
    const safeJSONParse = (str, defaultValue = []) => {
        if (!str) return defaultValue;
        try {
            const parsed = JSON.parse(str);
            return Array.isArray(parsed) ? parsed : defaultValue;
        } catch (e) {
            console.warn('Failed to parse JSON:', e);
            return defaultValue;
        }
    };

    const formatDoctorName = (name) => {
        if (!name) return 'Doctor';
        // Remove 'dr_' prefix if it exists
        let formattedName = name.replace(/^dr_/, '');
        // Split by underscores and capitalize each word
        formattedName = formattedName.split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
        // Remove all leading Dr. prefixes (with or without a period and spaces)
        formattedName = formattedName.replace(/^(Dr\.?\s*)+/i, '');
        // Add single Dr. prefix
        return `Dr. ${formattedName}`;
    };

    // Group doctor_specialities by speciality_id with null checks
    const groupedSpecialities = {};
    if (loadtype === 'hospitals') {
        if (doctorDetails?.hospital_specialities?.length > 0) {
            doctorDetails.hospital_specialities.forEach(item => {
                if (!item?.speciality_id) return;
                const id = item.speciality_id;
                if (!groupedSpecialities[id]) {
                    groupedSpecialities[id] = {
                        ...item,
                        services: []
                    };
                }
                if (item.services && Array.isArray(item.services)) {
                    groupedSpecialities[id].services.push(...item.services);
                }
            });
        }
    } else {
        if (doctorDetails?.doctor_specialities?.length > 0) {
            doctorDetails.doctor_specialities.forEach(item => {
                if (!item?.speciality_id) return;
                const id = item.speciality_id;
                if (!groupedSpecialities[id]) {
                    groupedSpecialities[id] = {
                        ...item,
                        services: []
                    };
                }
                if (item.services && Array.isArray(item.services)) {
                    groupedSpecialities[id].services.push(...item.services);
                }
            });
        }
    }


    // Convert to array for rendering
    const groupedArray = Object.values(groupedSpecialities);

    // Safe parsing of experiences and educations
    let experiences = [];
    let educations = [];
    if (loadtype === 'hospitals') {
        experiences = safeJSONParse(doctorDetails?.hospitals_experience_education?.[0]?.experiences);
        educations = safeJSONParse(doctorDetails?.hospitals_experience_education?.[0]?.educations);
    } else {
        experiences = safeJSONParse(doctorDetails?.doctor_experience_education?.[0]?.experiences);
        educations = safeJSONParse(doctorDetails?.doctor_experience_education?.[0]?.educations);
    }

    // Safe parsing of languages
    let languages = [];
    if (Array.isArray(data?.languages)) {
        languages = data.languages;
    } else if (typeof data?.languages === 'string') {
        try {
            const parsed = JSON.parse(data.languages);
            languages = Array.isArray(parsed) ? parsed : data.languages.split(',').map(l => l.trim());
        } catch {
            languages = data.languages.split(',').map(l => l.trim());
        }
    }

    // Safe parsing of awards
    let awards = [];
    if (loadtype === 'hospitals') {
        if (doctorDetails?.hospitals_awards_downloads?.[0]?.awards) {
            awards = safeJSONParse(doctorDetails.hospitals_awards_downloads[0].awards);
        }
    } else {
        if (doctorDetails?.doctor_awards_downloads?.[0]?.awards) {
            awards = safeJSONParse(doctorDetails.doctor_awards_downloads[0].awards);
        }
    }

    // Safe parsing of memberships
    let memberships = [];
    if (Array.isArray(data?.memberships)) {
        memberships = data.memberships;
    } else if (typeof data?.memberships === 'string') {
        memberships = safeJSONParse(data.memberships);
    }

    // Safe parsing of registrations
    let registrations = [];
    if (loadtype === 'hospitals') {
        if (doctorDetails?.hospitals_registrations?.[0]?.registrations) {
            registrations = safeJSONParse(doctorDetails.hospitals_registrations[0].registrations);
        }
    } else {
        if (doctorDetails?.doctor_registrations?.[0]?.registrations) {
            registrations = safeJSONParse(doctorDetails.doctor_registrations[0].registrations);
        }
    }

    // Safe parsing of downloads
    let downloads = [];
    if (loadtype === 'hospitals') {
        if (doctorDetails?.hospitals_awards_downloads?.[0]?.downloads) {
            downloads = safeJSONParse(doctorDetails.hospitals_awards_downloads[0].downloads);
        }
    } else {
        if (doctorDetails?.doctor_awards_downloads?.[0]?.downloads) {
            downloads = safeJSONParse(doctorDetails.doctor_awards_downloads[0].downloads);
        }
    }

    // Safe parsing of gallery images
    let images = [];
    if (loadtype === 'hospitals') {
        if (doctorDetails?.hospitals_gallery?.[0]?.images) {
            if (Array.isArray(doctorDetails.hospitals_gallery[0].images)) {
                console.log('doctorDetails.doctor_gallery[0].images type is array:', doctorDetails.hospitals_gallery[0].images);
                images = doctorDetails.hospitals_gallery[0].images;
            } else if (typeof doctorDetails.hospitals_gallery[0].images === 'string') {
                console.log('doctorDetails.doctor_gallery[0].images type is string:', doctorDetails.hospitals_gallery[0].images);
                images = safeJSONParse(doctorDetails.hospitals_gallery[0].images);
            }
        }
    } else {
        if (doctorDetails?.doctor_gallery?.[0]?.images) {
            if (Array.isArray(doctorDetails.doctor_gallery[0].images)) {
                console.log('doctorDetails.doctor_gallery[0].images type is array:', doctorDetails.doctor_gallery[0].images);
                images = doctorDetails.doctor_gallery[0].images;
            } else if (typeof doctorDetails.doctor_gallery[0].images === 'string') {
                console.log('doctorDetails.doctor_gallery[0].images type is string:', doctorDetails.doctor_gallery[0].images);
                images = safeJSONParse(doctorDetails.doctor_gallery[0].images);
            }
        }
    }

    // Safe parsing of gallery videos
    let videos = [];
    if (doctorDetails?.doctor_gallery?.[0]?.videos) {
        if (Array.isArray(doctorDetails.doctor_gallery[0].videos)) {
            videos = doctorDetails.doctor_gallery[0].videos;
        } else if (typeof doctorDetails.doctor_gallery[0].videos === 'string') {
            videos = safeJSONParse(doctorDetails.doctor_gallery[0].videos);
        }
    }

    // Safe parsing of social profiles
    let socialProfiles = {};
    if (doctorDetails?.doctor_social_profiles?.[0]?.social_profiles) {
        if (typeof doctorDetails.doctor_social_profiles[0].social_profiles === 'string') {
            try {
                socialProfiles = JSON.parse(doctorDetails.doctor_social_profiles[0].social_profiles);
            } catch {
                socialProfiles = {};
            }
        } else {
            socialProfiles = doctorDetails.doctor_social_profiles[0].social_profiles;
        }
    }

    function downloadImage(url, filename) {
        fetch(url, { mode: 'cors' })
            .then(response => response.blob())
            .then(blob => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(() => window.open(url, '_blank'));
    }

    return (
        <div className="tab-content dc-contentdoctab dc-haslayout ww">
            <div className="dc-userdetails-holder tab-pane active show" id="userdetails">
                <div className="dc-aboutdoc dc-aboutinfo">
                    <div className="dc-infotitle">
                        <h3> {decodeHtml(formatDoctorName(data?.display_name))}</h3>
                    </div>
                    <div className="dc-description">
                        <div className={`dc-description-text ${!isDescriptionExpanded ? 'dc-description-collapsed' : ''}`}>
                            <p>{data?.description || 'No description available.'}</p>
                        </div>
                        {data?.description && data.description.length > 100 && (
                            <div className="" style={{display: 'flex',justifyContent: 'flex-end'}}>
                                <button
                                    className="dc-view-more-btn align-self-end"
                                    onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
                                >
                                    {isDescriptionExpanded ? 'Show Less' : 'View All'}
                                </button>
                            </div>
                        )}
                        {/* <p>{data?.subheading || ''}</p> */}
                    </div>
                </div>
                <div className="dc-services-holder dc-aboutinfo">
                    <div className="dc-infotitle">
                        <h3>Offered Services</h3>
                    </div>
                    <div id="dc-accordion" className="dc-accordion" role="tablist" aria-multiselectable="true">
                        {groupedArray.length > 0 ? (
                            groupedArray.map((group, idx) => (
                                <div className="dc-panel" key={group.speciality_id || idx}>
                                    <div className="dc-paneltitle active">
                                        <figure className="dc-titleicon">
                                            <ImageShow
                                                image={group.specialities?.[0]?.url}
                                                style={{ width: '80px', height: '80px' }}
                                                fallback={<div style={{ width: '80px', height: '80px', background: '#f0f0f0' }} />}
                                            />
                                        </figure>
                                        <span>
                                            {group.specialities?.[0]?.name || group.speciality_name || 'Unnamed Specialty'}
                                            <em>{group.services?.length || 0}&nbsp;Service(s)</em>
                                        </span>
                                    </div>
                                    <div className="dc-panelcontent">
                                        <div className="dc-childaccordion" role="tablist" aria-multiselectable="true">
                                            {group.services?.map((service, sIdx) => {
                                                const serviceKey = `${group.speciality_id || idx}-${service?.id || sIdx}`;
                                                const isOpen = openService === serviceKey;
                                                return (
                                                    <div className="dc-subpanel" key={serviceKey}>
                                                        <div
                                                            className={`dc-subpaneltitle ${isOpen ? 'active' : ''}`}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => setOpenService(isOpen ? null : serviceKey)}
                                                        >
                                                            <span>
                                                                {service?.name || 'Unnamed Service'}
                                                                {service?.price && <em>${service.price}</em>}
                                                            </span>
                                                        </div>
                                                        {isOpen && (
                                                            <div className="dc-subpanelcontent">
                                                                <div className="dc-description">
                                                                    <p>{service?.description || group?.description || "No description available."}</p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="dc-panel">
                                <div className="dc-paneltitle">
                                    <h3>No services offered</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="dc-experience-holder dc-experiencedoc dc-aboutinfo">
                    <div className="dc-infotitle">
                        <h3>Experience</h3>
                    </div>
                    <ul className="dc-expandedu">
                        {experiences?.length > 0 ? experiences.map((exp, idx) => (
                            <li key={exp?.id || idx}>
                                <div className="dc-subpaneltitle" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>
                                        {exp?.job_title || 'Unnamed Position'}
                                        <em>({exp?.start_date || 'N/A'} - {exp?.ending_date || "Present"})</em>
                                    </span>
                                    {loadtype === 'hospitals' ? (
                                        // hear plus button need to add
                                        <div className="dc-subpaneltitle">
                                            <button className="dc-btn" onClick={() => setOpenExperience(exp?.id)}>+</button>
                                        </div>
                                    ) : (
                                        <em>{exp?.company_name || 'Unnamed Company'}</em>
                                    )}
                                </div>
                                {loadtype === 'hospitals' && openExperience === exp?.id && (
                                    <div className="dc-subpanelcontent">
                                        <p>{exp?.job_description || 'No description available.'}</p>
                                    </div>
                                )}
                            </li>
                        )) : (
                            <li>No experience information available.</li>
                        )}
                    </ul>
                </div>
                {loadtype === 'hospitals' ? (
                    <></>
                ) : (
                    <div className="dc-education-holder dc-aboutinfo">
                        <div className="dc-infotitle">
                            <h3>Education</h3>
                        </div>
                        <ul className="dc-expandedu">
                            {educations?.length > 0 ? educations.map((edu, idx) => (
                                <li key={edu?.id || idx}>
                                    <div className="dc-subpaneltitle">
                                        <span>
                                            {edu?.degree_title || 'Unnamed Degree'}
                                            <em>({edu?.start_date || 'N/A'} - {edu?.ending_date || 'N/A'})</em>
                                        </span>
                                        <em>{edu?.institute_name || 'Unnamed Institute'}</em>
                                    </div>
                                </li>
                            )) : (
                                <li>No education information available.</li>
                            )}
                        </ul>
                    </div>
                )}

                <div className="dc-specializations dc-aboutinfo">
                    <div className="dc-infotitle">
                        <h3>Specializations</h3>
                    </div>
                    <ul className="dc-specializationslist">
                        {groupedArray?.length > 0 ? (
                            groupedArray.map((group, idx) =>
                                group.specialities?.map((spec, specIdx) => (
                                    <li key={spec?.id || `${idx}-${specIdx}`}>
                                        <span>
                                            <Link
                                                to={spec?.slug ? `/search-doctors?speciality=${spec.slug}` : "#"}
                                                rel="tag"
                                            >
                                                {spec?.name || 'Unnamed Specialization'}
                                            </Link>
                                        </span>
                                    </li>
                                ))
                            )
                        ) : (
                            <li>No specializations available.</li>
                        )}
                    </ul>
                </div>

                <div className="dc-specializations dc-aboutinfo">
                    <div className="dc-infotitle">
                        <h3>Languages</h3>
                    </div>
                    <ul className="dc-specializationslist">
                        {languages?.length > 0 ? (
                            languages.map((lang, idx) => (
                                <li key={idx}>
                                    <span>{lang || 'Unnamed Language'}</span>
                                </li>
                            ))
                        ) : (
                            <li>No languages available.</li>
                        )}
                    </ul>
                </div>

                <div className="dc-awards-holder dc-aboutinfo">
                    <div className="dc-infotitle">
                        <h3>Awards and Recognitions</h3>
                    </div>
                    <ul className="dc-expandedu">
                        {awards?.length > 0 ? (
                            awards.map((award, idx) => (
                                <li key={award?.id || idx}>
                                    <span>
                                        <strong>{award?.title || 'Unnamed Award'}</strong>
                                        {award?.date && <em> ({new Date(award.date).getFullYear()})</em>}
                                        <br />
                                        {award?.description && (
                                            <span style={{ whiteSpace: 'pre-line' }}>{award.description}</span>
                                        )}
                                    </span>
                                </li>
                            ))
                        ) : (
                            <li>No awards or recognitions available.</li>
                        )}
                    </ul>
                </div>
                <div className="dc-specializations dc-aboutinfo dc-memberships">
                    <div className="dc-infotitle">
                        <h3>Memberships</h3>
                    </div>
                    <ul className="dc-specializationslist">
                        {memberships?.length > 0 ? (
                            memberships.map((membership, idx) => (
                                <li key={membership?.id || idx}>
                                    <span>{membership?.name || 'Unnamed Membership'}</span>
                                </li>
                            ))
                        ) : (
                            <li>No memberships available.</li>
                        )}
                    </ul>
                </div>

                <div className="dc-specializations dc-aboutinfo dc-memberships">
                    <div className="dc-infotitle">
                        <h3>Registrations</h3>
                    </div>
                    <ul className="dc-specializationslist">
                        {registrations?.length > 0 ? (
                            registrations.map((reg, idx) => (
                                <li key={reg?.id || idx}>
                                    <span>{reg?.registration_number || 'Unnamed Registration'}</span>
                                </li>
                            ))
                        ) : (
                            <li>No registrations available.</li>
                        )}
                    </ul>
                </div>

                <div className="dc-downloads-holder dc-aboutinfo">
                    <div className="dc-infotitle">
                        <h3>Downloads</h3>
                    </div>
                    <ul className="dc-downloads-listing">
                        {downloads?.length > 0 ? (
                            downloads.map((download, idx) => (
                                <li key={download?.id || idx}>
                                    <FileDownload
                                        fileid={download?.file_id}
                                        filename={download?.file || 'Unnamed File'}
                                    />
                                </li>
                            ))
                        ) : (
                            <li>No downloads available.</li>
                        )}
                    </ul>
                </div>
                <div className="dc-downloads-holder dc-aboutinfo dc-gall-holder">
                    <div className="dc-infotitle">
                        <h3>Gallery</h3>
                    </div>

                    <div className="">
                        <button
                            className={`dc-btn form-control ${galleryTab === 'images' ? 'active' : ''}`}
                            onClick={() => setGalleryTab('images')}
                            style={{ marginRight: '10px', width: '100px', marginBottom: '10px' }}
                        >
                            Images
                        </button>
                        <button
                            className={`dc-btn form-control ${galleryTab === 'videos' ? 'active' : ''}`}
                            onClick={() => setGalleryTab('videos')}
                            style={{ width: '100px', marginBottom: '10px' }}
                        >
                            Videos
                        </button>
                    </div>
                    <div className="gallery-img">
                        <div className="dc-projects">
                            {galleryTab === 'images' && images?.length > 0 ? images.map((img, idx) => (
                                <div className="dc-project dc-crprojects" key={img?.id || idx}>
                                    <a
                                        href="#"
                                        onClick={e => { e.preventDefault(); setPopupIndex(idx); setPopupType('images'); }}
                                    >
                                        <figure style={{ height: '150px' }}>
                                            <ImageShow url={img?.url} height={150} width={0} type="doctor" style={{ objectFit: 'cover' }} />
                                        </figure>
                                    </a>
                                </div>
                            )) : galleryTab === 'images' && (
                                <div className="dc-project dc-crprojects">
                                    <p>No images available.</p>
                                </div>
                            )}
                            {galleryTab === 'videos' && videos?.length > 0 ? videos.map((vid, idx) => (
                                <div className="dc-project dc-crprojects" key={vid?.id || idx}>
                                    <a
                                        href="#"
                                        onClick={e => { e.preventDefault(); setPopupIndex(idx); setPopupType('videos'); }}
                                    >
                                        <figure style={{ height: '150px' }}>
                                            {vid?.type === 'youtube' ? (
                                                <img
                                                    src={`https://img.youtube.com/vi/${vid?.name?.split('/embed/')[1]}/0.jpg`}
                                                    alt="YouTube Video"
                                                    style={{ height: '150px' }}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = 'path/to/fallback/image.jpg';
                                                    }}
                                                />
                                            ) : (
                                                <video
                                                    src={vid?.url}
                                                    style={{ height: '150px' }}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = 'path/to/fallback/video.mp4';
                                                    }}
                                                />
                                            )}
                                        </figure>
                                    </a>
                                </div>
                            )) : galleryTab === 'videos' && (
                                <div className="dc-project dc-crprojects">
                                    <p>No videos available.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {popupIndex !== null && (
                    <div className="gallery-popup-overlay" onClick={() => setPopupIndex(null)}>
                        <div className="gallery-popup" onClick={e => e.stopPropagation()}>
                            <button onClick={() => setPopupIndex(null)} className="close-btn">×</button>
                            {popupType === 'images' && images?.[popupIndex] && (

                                <>
                                    {console.log("images[popupIndex] :", images[popupIndex].url)}
                                    <ImageShow url={images[popupIndex].url} type="doctor" style={{ objectFit: 'cover' }} />

                                    <div>
                                        <button
                                            onClick={() => setPopupIndex((popupIndex - 1 + images.length) % images.length)}
                                            disabled={images.length <= 1}
                                        >←</button>
                                        <button
                                            onClick={() => setPopupIndex((popupIndex + 1) % images.length)}
                                            disabled={images.length <= 1}
                                        >→</button>
                                        <button
                                            onClick={() => downloadImage(images[popupIndex].url, images[popupIndex].name || 'image')}
                                        >
                                            Download
                                        </button>
                                    </div>
                                </>
                            )}
                            {popupType === 'videos' && videos?.[popupIndex] && (
                                <>
                                    {videos[popupIndex].type === 'youtube' ? (
                                        <iframe
                                            width="560"
                                            height="315"
                                            src={videos[popupIndex].name}
                                            title="YouTube video"
                                            frameBorder="0"
                                            allow="autoplay; encrypted-media"
                                            allowFullScreen
                                        ></iframe>
                                    ) : (
                                        <video
                                            src={videos[popupIndex].url}
                                            controls
                                            style={{ maxWidth: '90vw', maxHeight: '80vh' }}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = 'path/to/fallback/video.mp4';
                                            }}
                                        />
                                    )}
                                    <div>
                                        <button
                                            onClick={() => setPopupIndex((popupIndex - 1 + videos.length) % videos.length)}
                                            disabled={videos.length <= 1}
                                        >←</button>
                                        <button
                                            onClick={() => setPopupIndex((popupIndex + 1) % videos.length)}
                                            disabled={videos.length <= 1}
                                        >→</button>
                                        {videos[popupIndex].type !== 'youtube' && (
                                            <a href={videos[popupIndex].url} download target="_blank" rel="noopener noreferrer">
                                                <button>Download</button>
                                            </a>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}

            </div>
            <div className="dc-shareprofile">
                <ul className="d-flex dc-tags-social" style={{ gap: '10px' }}>
                    <li className="dc-sharejob">Social Profiles:</li>
                    {Object.entries(SOCIAL_ICONS).map(([key, { icon, label }]) =>
                        socialProfiles?.[key] ? (
                            <li key={key} className={`dc-${key}`} style={{ background: 'none', boxShadow: 'none', padding: 0 }}>
                                <a
                                    href={socialProfiles[key]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={label}
                                    style={{ background: 'none', boxShadow: 'none', padding: 0, color: '#222', fontSize: '1.5em' }}
                                >
                                    <i className={icon}></i>
                                </a>
                            </li>
                        ) : null
                    )}
                </ul>
            </div>

            <FeedbackPopup
                isOpen={isFeedbackOpen}
                onClose={() => setIsFeedbackOpen(false)}
                doctorId={data?.id}
            />
        </div>
    );
};

export default DoctorDetails;
